import { Field, Int, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class AdminUserListStatsDto {
  @Field(type => Int, { nullable: true })
  topReviewerApplicantCount?: number

  @Field(type => Int, { nullable: true })
  reportedCount?: number

  @Field(type => Int, { nullable: true })
  publisherApplicantCount?: number
}
